import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import CarInfo from '../CarInfo';
import ServicesGroupList from '../ServicesGroupList';

import { formatMileage } from '../../utils';

const propTypes = {
  car: PropTypes.shape({
    specs: PropTypes.shape({
      carPhoto: PropTypes.string,
      transmission: PropTypes.string,
      fuelType: PropTypes.string,
      engineCapacity: PropTypes.number,
    }),
    maker: PropTypes.shape({
      name: PropTypes.string,
    }),
    model: PropTypes.shape({
      name: PropTypes.string,
    }),
  }).isRequired,
  regNumber: PropTypes.string.isRequired,
  currentMileage: PropTypes.number.isRequired,
  lastServiceDate: PropTypes.string.isRequired,
  lastServiceMileage: PropTypes.number.isRequired,
  services: PropTypes.arrayOf(PropTypes.object).isRequired,
  withPlanDetails: PropTypes.bool,
};
const defaultProps = {
  withPlanDetails: false,
};

const QuoteCarInfo = ({
  car,
  regNumber,
  currentMileage,
  lastServiceDate,
  lastServiceMileage,
  services,
  withPlanDetails,
}) => (
  <Fragment>
    <CarInfo
      withPlanDetails={withPlanDetails}
      regNumber={regNumber}
      carPhoto={car.specs.carPhoto}
      currentMileage={currentMileage}
      carInfo={{
        carMaker: car.maker.name,
        carModel: car.model.name,
        transmission: car.specs.transmission,
        fuelType: car.specs.fuelType,
        engineSize: car.specs.engineCapacity,
      }}
    />
    <hr />
    <div>
      Based on the data provided, we calculate your last service should have
      been on &nbsp;
      {moment(lastServiceDate).format('Do MMMM YYYY')} at{' '}
      {formatMileage(lastServiceMileage)} miles. As such the schedule for your
      service plan is as follows and includes:
    </div>
    <ServicesGroupList services={services} />
  </Fragment>
);

QuoteCarInfo.propTypes = propTypes;
QuoteCarInfo.defaultProps = defaultProps;

export default QuoteCarInfo;
